import { dataGamepad } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGamepad = /*#__PURE__*/createIcon(dataGamepad)
export default IconGamepad
